import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';

export type DiscountType = 'fixedAmount' | 'percentage';

export const DISCOUNT_TYPE_OPTIONS: DropdownOption[] = [
  { label: 'Fixed amount', value: 'fixedAmount' },
  { label: 'Percentage', value: 'percentage' },
];

export const DISCOUNT_LABEL_PLACEHOLDER = '25% off';
export const DEFAULT_DISCOUNT_LABEL_COLOR = '#666666';
